var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formulate-input',_vm._b({attrs:{"label":_vm.appendedLabel,"type":"checkbox","options":_vm.appendedOptions}},'formulate-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }